import axios from "axios";
import { apiURL } from "../config/default";
import {
  MAIN_CATEGORIES_SUCCESS,
  MAIN_CATEGORIES_FAIL,
  CHILD_CATEGORIES_SUCCESS,
  CHILD_CATEGORIES_FAIL,
  SUB_CATEGORIES_SUCCESS,
  SUB_CATEGORIES_FAIL,
  CHILD_SUBCATEGORIES_SUCCESS,
  CHILD_SUBCATEGORIES_FAIL,
} from "./types";
import { addRecentCategories, getRecentCategories } from "../utils/storage";
export const mainCategories = () => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(`${apiURL}admin/main-categories`, _config);
    dispatch({
      type: MAIN_CATEGORIES_SUCCESS,
      payload: res.data,
    });
    return res;
  } catch (err) {
    const errors = err.response.data.error;

    console.log(errors);

    dispatch({
      type: MAIN_CATEGORIES_FAIL,
    });
  }
};

export const childCategories = () => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(`${apiURL}admin/categories`, _config);
    dispatch({
      type: CHILD_CATEGORIES_SUCCESS,
      payload: res.data,
    });
    return res;
  } catch (err) {
    const errors = err.response.data.error;

    console.log(errors);

    dispatch({
      type: CHILD_CATEGORIES_FAIL,
    });
  }
};

export const subCategories = () => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(`${apiURL}admin/sub-categories`, _config);
    dispatch({
      type: SUB_CATEGORIES_SUCCESS,
      payload: res.data,
    });
    return res;
  } catch (err) {
    const errors = err;

    console.log(errors);

    dispatch({
      type: SUB_CATEGORIES_FAIL,
    });
  }
};

export const childSubCategories = () => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(`${apiURL}admin/child-subcategories`, _config);
    dispatch({
      type: CHILD_SUBCATEGORIES_SUCCESS,
      payload: res.data,
    });
    return res;
  } catch (err) {
    const errors = err;

    console.log(errors);

    dispatch({
      type: CHILD_SUBCATEGORIES_FAIL,
    });
  }
};

export const singleCategoryData = (slug) => async () => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(`${apiURL}/category/${slug}`, _config);

    return res;
  } catch (err) {
    const errors = err.response.data.error;

    console.log(errors);
  }
};

export const getProducts = () => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(`${apiURL}/products`, _config);
    return res;
  } catch (err) {
    const errors = err.response.data.error;

    console.log(errors);
  }
};

export const getBanners = () => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(`${apiURL}admin/banners`, _config);
    return res.data;
  } catch (err) {
    const errors = err.response.data.error;

    console.log(errors);
  }
};
export const getSubCategory = (id) => async () => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(`${apiURL}getsubcategory/${id}`, _config);

    return res;
  } catch (err) {
    const errors = err.response.data.error;

    console.log(errors);
  }
};
export const getSubCategoryBySlug = (slug, page) => async () => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(
      `${apiURL}getsubcategorybyslug/${slug}?page=${page}`,
      _config
    );

    var categories = res.data[0];
    const object = {
      id: categories["_id"],
      name: categories["name"],
      slug: categories["slug"],
      image: categories["image"],
    };
    console.log(categories);
    let rows = [];
    var arr = getRecentCategories();
    if (arr) {
      if (arr.length > 19) {
        arr.splice(0, 1);
      }
      arr.forEach((item) => {
        if (item["id"] !== object["id"]) {
          rows.push(item);
        }
      });
    }

    rows.push(object);
    console.log(rows);

    addRecentCategories(rows, () => {});
    console.log(res.data[0]["name"]);
    return res;
  } catch (err) {
    const errors = [...err.response.data.error];
    return errors;

    console.log(errors);
  }
};
export const getChildCategoryBySlug = (slug) => async () => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(
      `${apiURL}getchildcategorybyslug/${slug}`,
      _config
    );

    return res;
  } catch (err) {
    const errors = err.response.data.error;

    console.log(errors);
  }
};
export const getChildCategory = (id) => async () => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(`${apiURL}getchildcategory/${id}`, _config);

    return res;
  } catch (err) {
    const errors = err.response.data.error;

    console.log(errors);
  }
};
export const getHomeAds = () => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(`${apiURL}admin/home-adss`, _config);
    return res.data;
  } catch (err) {
    const errors = err.response.data.error;

    console.log(errors);
  }
};
export const getCategoriesForProduct = (id) => async () => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(
      `${apiURL}getcategoriesforproduct/${id}`,
      _config
    );

    return res;
  } catch (err) {
    const errors = err.response.data.error;

    console.log(errors);
  }
};

export const getGroups = (formdata) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(
      `${apiURL}product-grouping/`,
      formdata,
      _config
    );
    return res;
  } catch (err) {
    const errors = err.response.data.error;

    if (errors) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    }
  }
};
